// AUTO-GENERATED from docs/Regolamento Tecnico 2025_Vers_1.0.pdf — do not edit manually.
// Run `pnpm codegen:openings` to regenerate (requires pdftotext).
//
// Ballot tables of the Italian Draughts Federation (F.I.D.), Regolamento Tecnico
// gennaio 2025: the 174 openings of the general table, each tagged with its FID
// strength code and the federal tables it belongs to.

/**
 * FID strength code (annex 10.2 / 10.3 legend). The digit is how lopsided the
 * opening is, the letter which colour it favours — `N` nero/black, `B` bianco/white.
 * `4` is considered winning for that colour with current knowledge.
 */
export type ForzaCode = 'PARI' | '1N' | '2N' | '3N' | '4N' | '1B' | '2B' | '3B' | '4B';

/** Federal table an opening belongs to. A and D are two-game matches only. */
export type BallotTable = 'A' | 'B' | 'C' | 'D';

export interface BallotOpening {
  /** Position in the general table (1-174) — the number arbiters announce. */
  readonly id: number;
  /** The 3 half-moves, in play order, as `from-to` on squares 1-32. */
  readonly moves: readonly string[];
  readonly forza: ForzaCode;
  readonly tables: readonly BallotTable[];
}

/** Legend as printed in the regulation. UI copy is translated via i18n, not from here. */
export const BALLOT_LEGEND: Readonly<Record<ForzaCode, string>> = {
  'PARI': 'Gioco equilibrato',
  '1N': 'Il Nero sta leggermente meglio',
  '2N': 'Il Nero sta decisamente meglio',
  '3N': 'Il Nero è formidabile',
  '4N': 'Il Nero è considerato vincente',
  '1B': 'Il Bianco sta leggermente meglio',
  '2B': 'Il Bianco sta decisamente meglio',
  '3B': 'Il Bianco è formidabile',
  '4B': 'Il Bianco è considerato vincente',
};

/** Strength level of a code: 0 for an even game, 1-4 otherwise. */
export function forzaLevel(forza: ForzaCode): 0 | 1 | 2 | 3 | 4 {
  return forza === 'PARI' ? 0 : (Number(forza[0]) as 1 | 2 | 3 | 4);
}

/**
 * Dama italiana — annexes 10.2.1-10.2.5. Half-moves in play order: 1st White,
 * 1st Black, 2nd White. Tables: A=40 (3N/3B), B=126, C=83 (⊂ B), D=8 (4N).
 */
export const ITALIAN_BALLOT: readonly BallotOpening[] = [
  { id: 1, moves: ['21-17', '9-13', '25-21'], forza: '1B', tables: ['B', 'C'] },
  { id: 2, moves: ['21-17', '9-13', '26-21'], forza: '1B', tables: ['B', 'C'] },
  { id: 3, moves: ['21-17', '9-13', '22-18'], forza: '3N', tables: ['A'] },
  { id: 4, moves: ['21-17', '10-13', '17-10'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 5, moves: ['21-17', '10-14', '26-21'], forza: '3N', tables: ['A'] },
  { id: 6, moves: ['21-17', '10-14', '17-13'], forza: '4N', tables: ['D'] },
  { id: 7, moves: ['21-17', '10-14', '22-18'], forza: '3N', tables: ['A'] },
  { id: 8, moves: ['21-17', '10-14', '22-19'], forza: '2N', tables: ['B'] },
  { id: 9, moves: ['21-17', '10-14', '23-19'], forza: '4N', tables: ['D'] },
  { id: 10, moves: ['21-17', '10-14', '23-20'], forza: '3N', tables: ['A'] },
  { id: 11, moves: ['21-17', '10-14', '24-20'], forza: '2N', tables: ['B'] },
  { id: 12, moves: ['21-17', '11-14', '25-21'], forza: '1N', tables: ['B', 'C'] },
  { id: 13, moves: ['21-17', '11-14', '26-21'], forza: '2N', tables: ['B'] },
  { id: 14, moves: ['21-17', '11-14', '22-18'], forza: '3N', tables: ['A'] },
  { id: 15, moves: ['21-17', '11-14', '22-19'], forza: '1N', tables: ['B', 'C'] },
  { id: 16, moves: ['21-17', '11-14', '23-19'], forza: '2N', tables: ['B'] },
  { id: 17, moves: ['21-17', '11-14', '23-20'], forza: '3N', tables: ['A'] },
  { id: 18, moves: ['21-17', '11-14', '24-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 19, moves: ['21-17', '11-15', '25-21'], forza: '1N', tables: ['B', 'C'] },
  { id: 20, moves: ['21-17', '11-15', '26-21'], forza: '1N', tables: ['B', 'C'] },
  { id: 21, moves: ['21-17', '11-15', '22-18'], forza: '1N', tables: ['B', 'C'] },
  { id: 22, moves: ['21-17', '11-15', '22-19'], forza: '3N', tables: ['A'] },
  { id: 23, moves: ['21-17', '11-15', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 24, moves: ['21-17', '12-15', '25-21'], forza: '3N', tables: ['A'] },
  { id: 25, moves: ['21-17', '12-15', '26-21'], forza: '1N', tables: ['B', 'C'] },
  { id: 26, moves: ['21-17', '12-15', '22-18'], forza: '3N', tables: ['A'] },
  { id: 27, moves: ['21-17', '12-15', '22-19'], forza: '3N', tables: ['A'] },
  { id: 28, moves: ['21-17', '12-15', '23-19'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 29, moves: ['21-17', '12-15', '23-20'], forza: '2N', tables: ['B'] },
  { id: 30, moves: ['21-17', '12-16', '25-21'], forza: '2N', tables: ['B'] },
  { id: 31, moves: ['21-17', '12-16', '26-21'], forza: '2N', tables: ['B'] },
  { id: 32, moves: ['21-17', '12-16', '22-18'], forza: '2N', tables: ['B'] },
  { id: 33, moves: ['21-17', '12-16', '22-19'], forza: '2N', tables: ['B'] },
  { id: 34, moves: ['21-17', '12-16', '23-19'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 35, moves: ['21-17', '12-16', '23-20'], forza: '3N', tables: ['A'] },
  { id: 36, moves: ['21-17', '12-16', '24-20'], forza: '4N', tables: ['D'] },
  { id: 37, moves: ['21-18', '10-13', '25-21'], forza: '2N', tables: ['B'] },
  { id: 38, moves: ['21-18', '10-13', '26-21'], forza: '2N', tables: ['B'] },
  { id: 39, moves: ['21-18', '10-13', '22-19'], forza: '3N', tables: ['A'] },
  { id: 40, moves: ['21-18', '10-13', '23-19'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 41, moves: ['21-18', '10-13', '23-20'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 42, moves: ['21-18', '10-14', '25-21'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 43, moves: ['21-18', '10-14', '22-19'], forza: '2N', tables: ['B'] },
  { id: 44, moves: ['21-18', '10-14', '23-19'], forza: '2N', tables: ['B'] },
  { id: 45, moves: ['21-18', '10-14', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 46, moves: ['21-18', '11-14', '18-11'], forza: '3B', tables: ['A'] },
  { id: 47, moves: ['21-18', '11-15', '25-21'], forza: '1B', tables: ['B', 'C'] },
  { id: 48, moves: ['21-18', '11-15', '26-21'], forza: '2N', tables: ['B'] },
  { id: 49, moves: ['21-18', '11-15', '23-20'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 50, moves: ['21-18', '11-15', '18-14'], forza: '2N', tables: ['B'] },
  { id: 51, moves: ['21-18', '11-15', '22-19'], forza: '3N', tables: ['A'] },
  { id: 52, moves: ['21-18', '12-15', '25-21'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 53, moves: ['21-18', '12-15', '23-19'], forza: '1B', tables: ['B', 'C'] },
  { id: 54, moves: ['21-18', '12-15', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 55, moves: ['21-18', '12-15', '22-19'], forza: '4N', tables: ['D'] },
  { id: 56, moves: ['21-18', '12-16', '25-21'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 57, moves: ['21-18', '12-16', '22-19'], forza: '1N', tables: ['B', 'C'] },
  { id: 58, moves: ['21-18', '12-16', '23-19'], forza: '1N', tables: ['B', 'C'] },
  { id: 59, moves: ['21-18', '12-16', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 60, moves: ['22-18', '10-13', '27-22'], forza: '1N', tables: ['B', 'C'] },
  { id: 61, moves: ['22-18', '10-13', '18-14'], forza: '3N', tables: ['A'] },
  { id: 62, moves: ['22-18', '10-13', '21-17'], forza: '3N', tables: ['A'] },
  { id: 63, moves: ['22-18', '10-13', '23-19'], forza: '3N', tables: ['A'] },
  { id: 64, moves: ['22-18', '10-13', '23-20'], forza: '3N', tables: ['A'] },
  { id: 65, moves: ['22-18', '10-14', '26-22'], forza: '2N', tables: ['B'] },
  { id: 66, moves: ['22-18', '10-14', '27-22'], forza: '3N', tables: ['A'] },
  { id: 67, moves: ['22-18', '10-14', '23-19'], forza: '1N', tables: ['B', 'C'] },
  { id: 68, moves: ['22-18', '10-14', '23-20'], forza: '2N', tables: ['B'] },
  { id: 69, moves: ['22-18', '10-14', '24-20'], forza: '4N', tables: ['D'] },
  { id: 70, moves: ['22-18', '11-14', '18-11'], forza: '3B', tables: ['A'] },
  { id: 71, moves: ['22-18', '11-15', '23-19'], forza: '3N', tables: ['A'] },
  { id: 72, moves: ['22-18', '11-15', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 73, moves: ['22-18', '11-15', '18-14'], forza: '1N', tables: ['B', 'C'] },
  { id: 74, moves: ['22-18', '11-15', '27-22'], forza: '2N', tables: ['B'] },
  { id: 75, moves: ['22-18', '12-15', '26-22'], forza: '2N', tables: ['B'] },
  { id: 76, moves: ['22-18', '12-15', '27-22'], forza: '2N', tables: ['B'] },
  { id: 77, moves: ['22-18', '12-15', '23-19'], forza: '4N', tables: ['D'] },
  { id: 78, moves: ['22-18', '12-15', '23-20'], forza: '2N', tables: ['B'] },
  { id: 79, moves: ['22-18', '12-15', '18-14'], forza: '2N', tables: ['B'] },
  { id: 80, moves: ['22-18', '12-16', '26-22'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 81, moves: ['22-18', '12-16', '27-22'], forza: '3N', tables: ['A'] },
  { id: 82, moves: ['22-18', '12-16', '23-19'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 83, moves: ['22-18', '12-16', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 84, moves: ['22-18', '12-16', '18-14'], forza: '2N', tables: ['B'] },
  { id: 85, moves: ['22-19', '9-13', '26-22'], forza: '2N', tables: ['B'] },
  { id: 86, moves: ['22-19', '9-13', '27-22'], forza: '3N', tables: ['A'] },
  { id: 87, moves: ['22-19', '9-13', '21-17'], forza: '3N', tables: ['A'] },
  { id: 88, moves: ['22-19', '9-13', '21-18'], forza: '3N', tables: ['A'] },
  { id: 89, moves: ['22-19', '9-13', '23-20'], forza: '1N', tables: ['B', 'C'] },
  { id: 90, moves: ['22-19', '9-13', '19-14'], forza: '2N', tables: ['B'] },
  { id: 91, moves: ['22-19', '10-13', '26-22'], forza: '2N', tables: ['B'] },
  { id: 92, moves: ['22-19', '10-13', '27-22'], forza: '2N', tables: ['B'] },
  { id: 93, moves: ['22-19', '10-13', '21-17'], forza: '2N', tables: ['B'] },
  { id: 94, moves: ['22-19', '10-13', '23-20'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 95, moves: ['22-19', '10-13', '19-15'], forza: '3N', tables: ['A'] },
  { id: 96, moves: ['22-19', '10-14', '19-10'], forza: '1N', tables: ['B', 'C'] },
  { id: 97, moves: ['22-19', '11-14', '26-22'], forza: '2N', tables: ['B'] },
  { id: 98, moves: ['22-19', '11-14', '27-22'], forza: '1N', tables: ['B', 'C'] },
  { id: 99, moves: ['22-19', '11-14', '21-18'], forza: '1N', tables: ['B', 'C'] },
  { id: 100, moves: ['22-19', '11-14', '23-20'], forza: '2N', tables: ['B'] },
  { id: 101, moves: ['22-19', '11-14', '24-20'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 102, moves: ['22-19', '11-15', '26-22'], forza: '1N', tables: ['B', 'C'] },
  { id: 103, moves: ['22-19', '11-15', '27-22'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 104, moves: ['22-19', '11-15', '23-20'], forza: '3N', tables: ['A'] },
  { id: 105, moves: ['22-19', '12-15', '19-12'], forza: '1B', tables: ['B', 'C'] },
  { id: 106, moves: ['22-19', '12-16', '26-22'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 107, moves: ['22-19', '12-16', '27-22'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 108, moves: ['22-19', '12-16', '19-15'], forza: '1B', tables: ['B', 'C'] },
  { id: 109, moves: ['22-19', '12-16', '23-20'], forza: '4N', tables: ['D'] },
  { id: 110, moves: ['22-19', '12-16', '24-20'], forza: '3N', tables: ['A'] },
  { id: 111, moves: ['23-19', '9-13', '28-23'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 112, moves: ['23-19', '9-13', '21-17'], forza: '2B', tables: ['B'] },
  { id: 113, moves: ['23-19', '9-13', '21-18'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 114, moves: ['23-19', '9-13', '22-18'], forza: '3N', tables: ['A'] },
  { id: 115, moves: ['23-19', '9-13', '19-15'], forza: '2N', tables: ['B'] },
  { id: 116, moves: ['23-19', '10-13', '28-23'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 117, moves: ['23-19', '10-13', '21-17'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 118, moves: ['23-19', '10-13', '19-14'], forza: '1N', tables: ['B', 'C'] },
  { id: 119, moves: ['23-19', '10-13', '19-15'], forza: '1B', tables: ['B', 'C'] },
  { id: 120, moves: ['23-19', '10-14', '19-10'], forza: '1B', tables: ['B', 'C'] },
  { id: 121, moves: ['23-19', '11-14', '28-23'], forza: '1B', tables: ['B', 'C'] },
  { id: 122, moves: ['23-19', '11-14', '21-18'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 123, moves: ['23-19', '11-14', '22-18'], forza: '1N', tables: ['B', 'C'] },
  { id: 124, moves: ['23-19', '11-14', '24-20'], forza: '3N', tables: ['A'] },
  { id: 125, moves: ['23-19', '11-14', '19-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 126, moves: ['23-19', '11-15', '28-23'], forza: '1B', tables: ['B', 'C'] },
  { id: 127, moves: ['23-19', '11-15', '21-17'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 128, moves: ['23-19', '11-15', '21-18'], forza: '1B', tables: ['B', 'C'] },
  { id: 129, moves: ['23-19', '12-15', '19-12'], forza: '2B', tables: ['B'] },
  { id: 130, moves: ['23-19', '12-16', '28-23'], forza: '1B', tables: ['B', 'C'] },
  { id: 131, moves: ['23-19', '12-16', '24-20'], forza: '3N', tables: ['A'] },
  { id: 132, moves: ['23-19', '12-16', '19-14'], forza: '1N', tables: ['B', 'C'] },
  { id: 133, moves: ['23-20', '9-13', '27-23'], forza: '3N', tables: ['A'] },
  { id: 134, moves: ['23-20', '9-13', '28-23'], forza: '2N', tables: ['B'] },
  { id: 135, moves: ['23-20', '9-13', '21-17'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 136, moves: ['23-20', '9-13', '21-18'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 137, moves: ['23-20', '9-13', '22-18'], forza: '3N', tables: ['A'] },
  { id: 138, moves: ['23-20', '9-13', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 139, moves: ['23-20', '10-13', '21-17'], forza: '3N', tables: ['A'] },
  { id: 140, moves: ['23-20', '10-13', '27-23'], forza: '2N', tables: ['B'] },
  { id: 141, moves: ['23-20', '10-13', '28-23'], forza: '1N', tables: ['B', 'C'] },
  { id: 142, moves: ['23-20', '10-13', '20-16'], forza: '2N', tables: ['B'] },
  { id: 143, moves: ['23-20', '10-14', '27-23'], forza: '3N', tables: ['A'] },
  { id: 144, moves: ['23-20', '10-14', '28-23'], forza: '1N', tables: ['B', 'C'] },
  { id: 145, moves: ['23-20', '10-14', '20-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 146, moves: ['23-20', '10-14', '20-16'], forza: '2N', tables: ['B'] },
  { id: 147, moves: ['23-20', '10-14', '22-19'], forza: '3N', tables: ['A'] },
  { id: 148, moves: ['23-20', '11-14', '27-23'], forza: '1N', tables: ['B', 'C'] },
  { id: 149, moves: ['23-20', '11-14', '28-23'], forza: '1N', tables: ['B', 'C'] },
  { id: 150, moves: ['23-20', '11-14', '21-18'], forza: '1N', tables: ['B', 'C'] },
  { id: 151, moves: ['23-20', '11-14', '22-18'], forza: '2N', tables: ['B'] },
  { id: 152, moves: ['23-20', '11-14', '20-16'], forza: '2N', tables: ['B'] },
  { id: 153, moves: ['23-20', '11-15', '20-11'], forza: '3B', tables: ['A'] },
  { id: 154, moves: ['23-20', '12-15', '27-23'], forza: '2N', tables: ['B'] },
  { id: 155, moves: ['23-20', '12-15', '28-23'], forza: '1N', tables: ['B', 'C'] },
  { id: 156, moves: ['23-20', '12-15', '20-16'], forza: '2N', tables: ['B'] },
  { id: 157, moves: ['23-20', '12-15', '22-19'], forza: '4N', tables: ['D'] },
  { id: 158, moves: ['23-20', '12-16', '20-15'], forza: '1B', tables: ['B', 'C'] },
  { id: 159, moves: ['23-20', '12-16', '27-23'], forza: '2N', tables: ['B'] },
  { id: 160, moves: ['24-20', '9-13', '21-17'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 161, moves: ['24-20', '9-13', '21-18'], forza: 'PARI', tables: ['B', 'C'] },
  { id: 162, moves: ['24-20', '9-13', '20-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 163, moves: ['24-20', '9-13', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 164, moves: ['24-20', '10-13', '20-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 165, moves: ['24-20', '10-13', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 166, moves: ['24-20', '10-14', '20-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 167, moves: ['24-20', '10-14', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 168, moves: ['24-20', '10-14', '21-18'], forza: '3N', tables: ['A'] },
  { id: 169, moves: ['24-20', '11-14', '20-15'], forza: '1N', tables: ['B', 'C'] },
  { id: 170, moves: ['24-20', '11-14', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 171, moves: ['24-20', '11-14', '21-18'], forza: '3N', tables: ['A'] },
  { id: 172, moves: ['24-20', '11-15', '20-11'], forza: '3B', tables: ['A'] },
  { id: 173, moves: ['24-20', '12-15', '20-16'], forza: '1N', tables: ['B', 'C'] },
  { id: 174, moves: ['24-20', '12-16', '28-24'], forza: '2N', tables: ['B'] },
];

/**
 * Dama inglese / English draughts — annexes 10.3.1-10.3.5. Half-moves in play order:
 * 1st Black, 1st White, 2nd Black (Black opens). Tables: A=156, B=133 (⊂ A),
 * C=93 (⊂ B), D=18 (4B).
 */
export const ENGLISH_BALLOT: readonly BallotOpening[] = [
  { id: 1, moves: ['9-13', '21-17', '5-9'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 2, moves: ['9-13', '21-17', '6-9'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 3, moves: ['9-13', '21-17', '10-14'], forza: '4B', tables: ['D'] },
  { id: 4, moves: ['9-13', '22-17', '13-22'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 5, moves: ['9-13', '22-18', '6-9'], forza: '3B', tables: ['A'] },
  { id: 6, moves: ['9-13', '22-18', '10-14'], forza: '3B', tables: ['A'] },
  { id: 7, moves: ['9-13', '22-18', '10-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 8, moves: ['9-13', '22-18', '11-15'], forza: '3B', tables: ['A'] },
  { id: 9, moves: ['9-13', '22-18', '11-16'], forza: '3B', tables: ['A'] },
  { id: 10, moves: ['9-13', '22-18', '12-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 11, moves: ['9-13', '23-18', '5-9'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 12, moves: ['9-13', '23-18', '6-9'], forza: '3B', tables: ['A'] },
  { id: 13, moves: ['9-13', '23-18', '10-14'], forza: '4B', tables: ['D'] },
  { id: 14, moves: ['9-13', '23-18', '10-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 15, moves: ['9-13', '23-18', '11-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 16, moves: ['9-13', '23-18', '11-16'], forza: '3B', tables: ['A'] },
  { id: 17, moves: ['9-13', '23-18', '12-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 18, moves: ['9-13', '23-19', '5-9'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 19, moves: ['9-13', '23-19', '6-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 20, moves: ['9-13', '23-19', '10-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 21, moves: ['9-13', '23-19', '10-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 22, moves: ['9-13', '23-19', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 23, moves: ['9-13', '24-19', '5-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 24, moves: ['9-13', '24-19', '6-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 25, moves: ['9-13', '24-19', '10-14'], forza: '3B', tables: ['A'] },
  { id: 26, moves: ['9-13', '24-19', '10-15'], forza: '4B', tables: ['D'] },
  { id: 27, moves: ['9-13', '24-19', '11-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 28, moves: ['9-13', '24-19', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 29, moves: ['9-13', '24-20', '5-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 30, moves: ['9-13', '24-20', '6-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 31, moves: ['9-13', '24-20', '10-14'], forza: '2B', tables: ['A', 'B'] },
  { id: 32, moves: ['9-13', '24-20', '10-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 33, moves: ['9-13', '24-20', '11-15'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 34, moves: ['9-13', '24-20', '11-16'], forza: '3B', tables: ['A'] },
  { id: 35, moves: ['9-13', '24-20', '12-16'], forza: '4B', tables: ['D'] },
  { id: 36, moves: ['9-14', '22-17', '5-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 37, moves: ['9-14', '22-17', '6-9'], forza: '2B', tables: ['A', 'B'] },
  { id: 38, moves: ['9-14', '22-17', '11-15'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 39, moves: ['9-14', '22-17', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 40, moves: ['9-14', '22-18', '5-9'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 41, moves: ['9-14', '22-18', '10-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 42, moves: ['9-14', '22-18', '11-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 43, moves: ['9-14', '22-18', '11-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 44, moves: ['9-14', '22-18', '12-16'], forza: '4B', tables: ['D'] },
  { id: 45, moves: ['9-14', '22-18', '14-17'], forza: '4B', tables: ['D'] },
  { id: 46, moves: ['9-14', '23-18', '14-23'], forza: '3N', tables: ['A'] },
  { id: 47, moves: ['9-14', '23-19', '5-9'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 48, moves: ['9-14', '23-19', '10-15'], forza: '4B', tables: ['D'] },
  { id: 49, moves: ['9-14', '23-19', '11-16'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 50, moves: ['9-14', '23-19', '14-18'], forza: '2B', tables: ['A', 'B'] },
  { id: 51, moves: ['9-14', '24-19', '5-9'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 52, moves: ['9-14', '24-19', '10-15'], forza: '4B', tables: ['D'] },
  { id: 53, moves: ['9-14', '24-19', '11-15'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 54, moves: ['9-14', '24-19', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 55, moves: ['9-14', '24-20', '5-9'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 56, moves: ['9-14', '24-20', '10-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 57, moves: ['9-14', '24-20', '11-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 58, moves: ['9-14', '24-20', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 59, moves: ['10-14', '22-17', '7-10'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 60, moves: ['10-14', '22-17', '9-13'], forza: '3B', tables: ['A'] },
  { id: 61, moves: ['10-14', '22-17', '11-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 62, moves: ['10-14', '22-17', '11-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 63, moves: ['10-14', '22-17', '14-18'], forza: '3B', tables: ['A'] },
  { id: 64, moves: ['10-14', '22-18', '6-10'], forza: '3B', tables: ['A'] },
  { id: 65, moves: ['10-14', '22-18', '7-10'], forza: '3B', tables: ['A'] },
  { id: 66, moves: ['10-14', '22-18', '11-15'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 67, moves: ['10-14', '22-18', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 68, moves: ['10-14', '22-18', '12-16'], forza: '3B', tables: ['A'] },
  { id: 69, moves: ['10-14', '23-18', '14-23'], forza: '2N', tables: ['A', 'B'] },
  { id: 70, moves: ['10-14', '23-19', '6-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 71, moves: ['10-14', '23-19', '7-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 72, moves: ['10-14', '23-19', '11-15'], forza: '2B', tables: ['A', 'B'] },
  { id: 73, moves: ['10-14', '23-19', '11-16'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 74, moves: ['10-14', '23-19', '14-18'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 75, moves: ['10-14', '24-19', '6-10'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 76, moves: ['10-14', '24-19', '7-10'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 77, moves: ['10-14', '24-19', '11-15'], forza: '4B', tables: ['D'] },
  { id: 78, moves: ['10-14', '24-19', '11-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 79, moves: ['10-14', '24-19', '14-18'], forza: '2B', tables: ['A', 'B'] },
  { id: 80, moves: ['10-14', '24-20', '6-10'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 81, moves: ['10-14', '24-20', '7-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 82, moves: ['10-14', '24-20', '11-15'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 83, moves: ['10-14', '24-20', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 84, moves: ['10-14', '24-20', '14-18'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 85, moves: ['10-15', '21-17', '6-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 86, moves: ['10-15', '21-17', '7-10'], forza: '3B', tables: ['A'] },
  { id: 87, moves: ['10-15', '21-17', '9-13'], forza: '3B', tables: ['A'] },
  { id: 88, moves: ['10-15', '21-17', '9-14'], forza: '4B', tables: ['D'] },
  { id: 89, moves: ['10-15', '21-17', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 90, moves: ['10-15', '21-17', '15-18'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 91, moves: ['10-15', '22-17', '6-10'], forza: '3B', tables: ['A'] },
  { id: 92, moves: ['10-15', '22-17', '7-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 93, moves: ['10-15', '22-17', '9-13'], forza: '2B', tables: ['A', 'B'] },
  { id: 94, moves: ['10-15', '22-17', '9-14'], forza: '4B', tables: ['D'] },
  { id: 95, moves: ['10-15', '22-17', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 96, moves: ['10-15', '22-17', '15-19'], forza: '3B', tables: ['A'] },
  { id: 97, moves: ['10-15', '22-18', '15-22'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 98, moves: ['10-15', '23-18', '6-10'], forza: '2B', tables: ['A', 'B'] },
  { id: 99, moves: ['10-15', '23-18', '7-10'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 100, moves: ['10-15', '23-18', '9-14'], forza: '2B', tables: ['A', 'B'] },
  { id: 101, moves: ['10-15', '23-18', '11-16'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 102, moves: ['10-15', '23-18', '12-16'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 103, moves: ['10-15', '23-19', '6-10'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 104, moves: ['10-15', '23-19', '7-10'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 105, moves: ['10-15', '23-19', '11-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 106, moves: ['10-15', '24-19', '15-24'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 107, moves: ['10-15', '24-20', '6-10'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 108, moves: ['10-15', '24-20', '7-10'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 109, moves: ['10-15', '24-20', '11-16'], forza: '4B', tables: ['D'] },
  { id: 110, moves: ['10-15', '24-20', '15-19'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 111, moves: ['11-15', '21-17', '8-11'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 112, moves: ['11-15', '21-17', '9-13'], forza: '2N', tables: ['A', 'B'] },
  { id: 113, moves: ['11-15', '21-17', '9-14'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 114, moves: ['11-15', '21-17', '10-14'], forza: '4B', tables: ['D'] },
  { id: 115, moves: ['11-15', '21-17', '15-19'], forza: '2B', tables: ['A', 'B'] },
  { id: 116, moves: ['11-15', '22-17', '8-11'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 117, moves: ['11-15', '22-17', '9-13'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 118, moves: ['11-15', '22-17', '15-18'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 119, moves: ['11-15', '22-17', '15-19'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 120, moves: ['11-15', '22-18', '15-22'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 121, moves: ['11-15', '23-18', '8-11'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 122, moves: ['11-15', '23-18', '9-14'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 123, moves: ['11-15', '23-18', '10-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 124, moves: ['11-15', '23-18', '12-16'], forza: '3B', tables: ['A'] },
  { id: 125, moves: ['11-15', '23-18', '15-19'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 126, moves: ['11-15', '23-19', '8-11'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 127, moves: ['11-15', '23-19', '9-13'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 128, moves: ['11-15', '23-19', '9-14'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 129, moves: ['11-15', '24-19', '15-24'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 130, moves: ['11-15', '24-20', '8-11'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 131, moves: ['11-15', '24-20', '12-16'], forza: '2B', tables: ['A', 'B'] },
  { id: 132, moves: ['11-15', '24-20', '15-18'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 133, moves: ['11-16', '21-17', '7-11'], forza: '3B', tables: ['A'] },
  { id: 134, moves: ['11-16', '21-17', '8-11'], forza: '2B', tables: ['A', 'B'] },
  { id: 135, moves: ['11-16', '21-17', '9-13'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 136, moves: ['11-16', '21-17', '9-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 137, moves: ['11-16', '21-17', '10-14'], forza: '4B', tables: ['D'] },
  { id: 138, moves: ['11-16', '21-17', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 139, moves: ['11-16', '22-17', '7-11'], forza: '2B', tables: ['A', 'B'] },
  { id: 140, moves: ['11-16', '22-17', '8-11'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 141, moves: ['11-16', '22-17', '9-13'], forza: '3B', tables: ['A'] },
  { id: 142, moves: ['11-16', '22-17', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 143, moves: ['11-16', '22-18', '7-11'], forza: '3B', tables: ['A'] },
  { id: 144, moves: ['11-16', '22-18', '8-11'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 145, moves: ['11-16', '22-18', '10-15'], forza: '4B', tables: ['D'] },
  { id: 146, moves: ['11-16', '22-18', '16-19'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 147, moves: ['11-16', '22-18', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 148, moves: ['11-16', '23-18', '7-11'], forza: '2B', tables: ['A', 'B'] },
  { id: 149, moves: ['11-16', '23-18', '8-11'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 150, moves: ['11-16', '23-18', '9-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 151, moves: ['11-16', '23-18', '10-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 152, moves: ['11-16', '23-18', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 153, moves: ['11-16', '23-19', '16-23'], forza: '3N', tables: ['A'] },
  { id: 154, moves: ['11-16', '24-19', '7-11'], forza: '2B', tables: ['A', 'B'] },
  { id: 155, moves: ['11-16', '24-19', '8-11'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 156, moves: ['11-16', '24-19', '10-15'], forza: '4B', tables: ['D'] },
  { id: 157, moves: ['11-16', '24-19', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 158, moves: ['11-16', '24-20', '7-11'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 159, moves: ['11-16', '24-20', '16-19'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 160, moves: ['12-16', '21-17', '9-13'], forza: '1N', tables: ['A', 'B', 'C'] },
  { id: 161, moves: ['12-16', '21-17', '9-14'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 162, moves: ['12-16', '21-17', '16-19'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 163, moves: ['12-16', '21-17', '16-20'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 164, moves: ['12-16', '22-17', '16-19'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 165, moves: ['12-16', '22-17', '16-20'], forza: 'PARI', tables: ['A', 'B', 'C'] },
  { id: 166, moves: ['12-16', '22-18', '16-19'], forza: '2B', tables: ['A', 'B'] },
  { id: 167, moves: ['12-16', '22-18', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 168, moves: ['12-16', '23-18', '9-14'], forza: '4B', tables: ['D'] },
  { id: 169, moves: ['12-16', '23-18', '16-19'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 170, moves: ['12-16', '23-18', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 171, moves: ['12-16', '23-19', '16-23'], forza: '4B', tables: ['D'] },
  { id: 172, moves: ['12-16', '24-19', '16-20'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 173, moves: ['12-16', '24-20', '8-12'], forza: '1B', tables: ['A', 'B', 'C'] },
  { id: 174, moves: ['12-16', '24-20', '10-15'], forza: '2B', tables: ['A', 'B'] },
];

/** Cardinality of every federal table, asserted at generation time. */
export const BALLOT_TABLE_SIZES = {
  italian: { A: 40, B: 126, C: 83, D: 8 },
  english: { A: 156, B: 133, C: 93, D: 18 },
} as const;
